import { render } from "./LoanDetails.vue?vue&type=template&id=05e008ac&scoped=true"
import script from "./LoanDetails.vue?vue&type=script&lang=js"
export * from "./LoanDetails.vue?vue&type=script&lang=js"

import "./LoanDetails.vue?vue&type=style&index=0&id=05e008ac&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e008ac"]])

export default __exports__